import { render, staticRenderFns } from "./PageSilhouetteSelector.vue?vue&type=template&id=053ad33f&scoped=true&"
import script from "./PageSilhouetteSelector.vue?vue&type=script&lang=ts&"
export * from "./PageSilhouetteSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PageSilhouetteSelector.vue?vue&type=style&index=0&id=053ad33f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ad33f",
  null
  
)

export default component.exports